import { useCentralizedProviderData } from '@crehana/auth';

import type { OrganizationInfo } from '../../hooks/useOrganizationTheme/types';
import B2BOrgLayout from './B2BOrgLayout';

interface ConditionalB2BLayoutProps {
  isB2B: boolean;
  organizationInfo?: OrganizationInfo;
  organizationSlug?: string;
}

const B2BCustomTheme: React.FC<ConditionalB2BLayoutProps> = ({
  isB2B,
  organizationInfo,
  organizationSlug,
}) => {
  const { loading, me: centralizedMe } = useCentralizedProviderData();

  // do not render the custom b2b theme if the user is centralized
  // centralized has its own branding theme provider that customize colors, favicon, logos, etc
  if (
    loading ||
    // user is centralized
    centralizedMe?.user.id
  ) {
    return null;
  }

  const shouldRenderCustomB2BTheme =
    isB2B && !!organizationSlug && organizationInfo?.lookAndFeel;

  if (shouldRenderCustomB2BTheme) {
    return <B2BOrgLayout orgInfo={organizationInfo} />;
  }

  return null;
};

export default B2BCustomTheme;
